<template>
  <modal-auth modal-type="login" :data="data">
    <h5 class="text-center">{{$t('logIn')}}</h5>
    <br>
    <p class="login-label">{{$t('emailAddressUpper')}} <span style="color: red">*</span></p>
    <input type="email" class="form-control login-input" :placeholder="$t('enterEmail')" v-model="data.email" required/>
    <p class="login-label">{{$t('passwordUpper')}} <span style="color: red">*</span></p>
    <input type="password" class="form-control" :placeholder="$t('password')" v-model="data.password" required/>
    <br>
    <div class="text-center">
      <button v-if="!isLoading" class="btn btn-fill btn-danger btn-round btn-sm btn-wd full-width" type="submit">{{$t('logIn')}}</button>
      <sync-loader v-if="isLoading" class="text-center" color="red"></sync-loader>
    </div>
    <div class="remember-block">
      <router-link :to="{name: 'register'}" class="link">{{$t('register')}}</router-link>
      <span class="stick">|</span>
      <router-link :to="{name: 'reset'}" class="link">{{$t('forgotYourPassword')}}</router-link>
    </div>
    <div class="text-center">

      <google-sign-in-button @click="authGoogle()"/>
    </div>
  </modal-auth>
</template>

<script>
  import ModalAuth from '../components/ModalAuth'
  import GoogleSignInButton from '../components/GoogleSignInButton'
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        data: {
          email: '',
          password: ''
        },
        loopbackBase: process.env.VUE_APP_USTAGE_BASE || 'http://localhost:3000',
      }
    },
    computed: {
      ...mapGetters(['isLoading'])
    },
    methods: {
      authGoogle() {
         window.open(this.loopbackBase + '/auth/google', '_self');
      }
    },
    components: { ModalAuth, GoogleSignInButton, syncLoader },
  }
</script>

<style>
a.link {
  font-size: 0.9rem;
  color: black; 
  text-decoration: underline;
}
a.link:hover {
  color: black;
}
span.stick {
  color: gray;
  padding-left: 5px;
  padding-right: 5px;
}
button.full-width {
  width: 100%;
  font-size: 1rem !important;
}
.remember-block {
  text-align: center;
  padding-top: 5px;
  padding-bottom: 10px;
}
.login-label {
  margin-bottom: 10px !important;
}
.login-input {
  margin-bottom: 15px;
}
</style>